import { useState, useCallback } from "react";
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";
import { UserOutlined } from "@ant-design/icons";
import { Row, Col, Modal, Form, Typography } from "antd";

import colors from "../../../../colors";
import CustomIcon from "../../../app/generic/customIcon";
import InputItem from "../../../app/generic/form/inputItem";

const { Title } = Typography;

const PasswordModal = ({ open, onCancel, onSetPassword }) => {
  const [form] = Form.useForm();

  const formItemLayout = {
    labelCol: { span: 20 },
    wrapperCol: { span: 20 },
    colon: false,
  };

  const [loading, setLoading] = useState();
  const handleSubmit = useCallback(
    (values) => {
      onSetPassword(values.passwordModal);
      setLoading(true);
    },
    [onSetPassword]
  );

  const handleOk = useCallback(() => {
    form.submit();
  }, [form]);

  const navigate = useNavigate();
  const handleCancel = useCallback(() => {
    onCancel ? onCancel() : navigate("/");
  }, [onCancel, navigate]);

  return (
    <Modal
      width={666}
      open={open}
      onOk={handleOk}
      okText={
        <FormattedMessage
          id="registration.security.write"
          defaultMessage="Odeslat"
        />
      }
      closable={true}
      onCancel={handleCancel}
      confirmLoading={loading}
    >
      <Row gutter={20}>
        <Col>
          <CustomIcon size={25} color={colors.YELLOW} icon={UserOutlined} />
        </Col>
        <Col>
          <Title level={4}>
            <FormattedMessage
              id="registration.security.password"
              defaultMessage="Přístupový kód"
            />
          </Title>
        </Col>
      </Row>
      <Row justify="center">
        <Col span={20}>
          <Form
            form={form}
            layout="vertical"
            {...formItemLayout}
            onFinish={handleSubmit}
          >
            <InputItem
              password
              autoFocus
              fieldName="passwordModal"
              formItemLayout={formItemLayout}
              message={
                <FormattedMessage
                  id="registration.security.password.message"
                  defaultMessage="Zadejte prosím přístupový kód"
                />
              }
            />
          </Form>
        </Col>
      </Row>
    </Modal>
  );
};

export default PasswordModal;
